import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      "nav.nodes": "NODES",
      "nav.shop": "SHOP",
      "nav.leaderboard": "LEADERBOARD",
      "nav.referral": "REFERRAL",
      "nav.daily": "DAILY",
      "nav.settings": "SETTINGS",
      "nav.help": "HELP",
      "nav.inventory": "INVENTORY",
      "nav.achievements": "ACHIEVEMENTS",
      "nav.admin": "ADMIN",

      // Dashboard
      "dashboard.title": "NODE EMPIRE DASHBOARD",
      "dashboard.balance": "ETCPOWv2 Balance",
      "dashboard.loading": "Loading...",
      "dashboard.connect": "Please connect your wallet to access Node Empire",
      "dashboard.connect_wallet": "Connect Wallet",
      "dashboard.disconnect": "Disconnect",
      "dashboard.node_commander": "Node Commander",
      "dashboard.connect_description": "Connect your wallet to start managing your virtual node empire",
      "dashboard.purchase_starter": "Purchase Starter Node",
      "dashboard.purchase_price": "(100 ETCPOWv2)",
      "dashboard.your_nodes": "Your Nodes",
      "dashboard.active": "ACTIVE",
      "dashboard.inactive": "INACTIVE",
      "dashboard.pending": "Pending",
      "dashboard.deactivate": "Deactivate",
      "dashboard.activate": "Activate",
      "dashboard.claim": "Claim",
      "dashboard.node_empire": "Node Empire",
      "dashboard.node_empire_desc": "Manage your virtual node empire and earn ETCPOWv2 rewards",
      "dashboard.total_nodes": "Total Nodes",
      "dashboard.active_nodes": "Active Nodes",
      "dashboard.node_details": "Node Details",
      "dashboard.hash_power": "Hash Power",
      "dashboard.bandwidth": "Bandwidth",
      "dashboard.uptime": "Uptime",
      "dashboard.deactivate_node": "Deactivate Node",
      "dashboard.activate_node": "Activate Node",
      "dashboard.claim_rewards": "Claim Rewards",

      // Network
      "network.topology": "NETWORK TOPOLOGY",
      "network.terminal": "SYSTEM TERMINAL",
      "network.selected_node": "SELECTED NODE",
      "network.node_id": "NODE ID:",
      "network.status": "STATUS:",
      "network.hash_power": "HASH POWER:",
      "network.bandwidth": "BANDWIDTH:",
      "network.uptime": "UPTIME:",
      "network.pending": "PENDING:",
      "network.active": "ACTIVE",
      "network.inactive": "INACTIVE",
      "network.online": "ONLINE",
      "network.offline": "OFFLINE",

      // Actions
      "actions.upgrade": "UPGRADE",
      "actions.analytics": "ANALYTICS",

      // Node Management
      "nodes.purchase": "PURCHASE STARTER NODE",
      "nodes.upgrade": "UPGRADE NODE",
      "nodes.activate": "ACTIVATE",
      "nodes.deactivate": "DEACTIVATE",
      "nodes.claim": "CLAIM REWARDS",
      "nodes.pending": "PENDING",
      "nodes.tier": "TIER:",
      "nodes.hash": "HASH:",
      "nodes.band": "BAND:",
      "nodes.uptime": "UPTIME:",

      // Shop
      "shop.title": "NODE EMPIRE SHOP",
      "shop.balance": "ETCPOWv2 Balance",
      "shop.purchase": "PURCHASE",
      "shop.unavailable": "UNAVAILABLE",

      // Items
      "items.node": "NODES",
      "items.chest": "CHESTS",
      "items.upgrade": "UPGRADES",

      // Chests
      "chests.basic": "Basic Chest",
      "chests.uncommon": "Uncommon Chest",
      "chests.rare": "Rare Chest",
      "chests.epic": "Epic Chest",
      "chests.legendary": "Legendary Chest",
      "chests.basic_desc": "Contains random rewards and upgrades",
      "chests.uncommon_desc": "Better rewards than basic chest",
      "chests.rare_desc": "High-tier rewards and upgrades",
      "chests.epic_desc": "Premium rewards and legendary upgrades",
      "chests.legendary_desc": "Ultimate rewards and exclusive items",

      // Daily Quests
      "daily.title": "DAILY QUESTS",
      "daily.reset": "Resets in",
      "daily.node_owner": "Node Owner",
      "daily.chest_owner": "Chest Collector",
      "daily.upgrade_owner": "Upgrade Collector",
      "daily.reward_collector": "Reward Collector",
      "daily.node_desc": "Purchase at least 1 node today (streak only)",
      "daily.chest_desc": "Open at least 3 chests today (streak only)",
      "daily.upgrade_desc": "Apply at least 2 upgrades today (streak only)",
      "daily.reward_desc": "Claim on-chain rewards from at least 1 node today (quest tracks locally)",
      "daily.in_progress": "IN PROGRESS",
      "daily.completed": "COMPLETED",
      "daily.completed_msg": "Streak noted!\n\n✅ {{title}}\n\nLocal habit tracker — no ETCPOWv2 faucet payout.",
      "daily.loading_quests": "LOADING QUESTS...",
      "daily.completed_button": "TRACKED",
      "daily.in_progress_button": "IN PROGRESS",

      // Rarity Levels
      "rarity.common": "Common",
      "rarity.uncommon": "Uncommon",
      "rarity.rare": "Rare",
      "rarity.epic": "Epic",
      "rarity.legendary": "Legendary",
      "rarity.unknown": "Unknown",

      // Admin Panel
      "admin.title": "ADMIN CONTROLS",
      "admin.owner_mode": "OWNER MODE",
      "admin.price_controls": "Price Controls",
      "admin.node_price": "Node Price (ETCPOWv2)",
      "admin.chest_prices": "Chest Prices (ETCPOWv2)",
      "admin.chest_tier_basic": "Basic",
      "admin.chest_tier_uncommon": "Uncommon",
      "admin.chest_tier_rare": "Rare",
      "admin.chest_tier_epic": "Epic",
      "admin.chest_tier_legendary": "Legendary",
      "admin.reward_rate": "Reward Rate (ETCPOWv2/hour)",
      "admin.upgrade_price": "Upgrade Base Price (ETCPOWv2)",
      "admin.referral_reward": "Referral Reward (ETCPOWv2)",
      "admin.referral_bonus": "Referral Bonus (%)",
      "admin.contract_management": "Contract Management",
      "admin.contract_balances": "Contract Balances",
      "admin.fund_contract": "Fund Contract",
      "admin.withdraw_funds": "Withdraw Funds",
      "admin.game_controls": "Game Controls",
      "admin.pause_game": "Pause Game",
      "admin.resume_game": "Resume Game",
      "admin.update": "Update",
      "admin.set": "Set",

      // Achievements
      "achievements.title": "ACHIEVEMENTS",
      "achievements.loading": "LOADING ACHIEVEMENTS...",
      "achievements.all": "ALL",
      "achievements.nodes": "NODES",
      "achievements.upgrades": "UPGRADES",
      "achievements.chests": "CHESTS",
      "achievements.earnings": "EARNINGS",
      "achievements.special": "SPECIAL",
      "achievements.reward": "REWARD:",
      "achievements.completed": "✓ COMPLETED",
      "achievements.progress": "%",
      "achievements.unlocked": "UNLOCKED:",

      // Achievement Names
      "achievement.node_pioneer": "Node Pioneer",
      "achievement.node_collector": "Node Collector",
      "achievement.node_master": "Node Master",
      "achievement.upgrade_beginner": "Upgrade Beginner",
      "achievement.upgrade_expert": "Upgrade Expert",
      "achievement.lucky_opener": "Lucky Opener",
      "achievement.chest_hunter": "Chest Hunter",
      "achievement.first_claim": "First Claim",
      "achievement.reward_collector": "Reward Collector",
      "achievement.early_adopter": "Early Adopter",

      // Achievement Descriptions
      "achievement.node_pioneer_desc": "Purchase your first virtual node",
      "achievement.node_collector_desc": "Own 5 virtual nodes",
      "achievement.node_master_desc": "Own 10 virtual nodes",
      "achievement.upgrade_beginner_desc": "Apply your first upgrade",
      "achievement.upgrade_expert_desc": "Apply 10 upgrades",
      "achievement.lucky_opener_desc": "Open 10 chests",
      "achievement.chest_hunter_desc": "Open 25 chests",
      "achievement.first_claim_desc": "Claim your first rewards",
      "achievement.reward_collector_desc": "Claim 100 ETCPOWv2 in total",
      "achievement.early_adopter_desc": "Be one of the first 100 users",

      // Settings
      "settings.title": "SETTINGS",
      "settings.config": "CONFIGURATION",
      "settings.general": "GENERAL",
      "settings.language": "LANGUAGE",
      "settings.advanced": "ADVANCED",
      "settings.account": "ACCOUNT",

      // Setting Labels
      "settings.sound": "SOUND EFFECTS",
      "settings.particles": "PARTICLE EFFECTS",
      "settings.notifications": "NOTIFICATIONS",
      "settings.language_select": "LANGUAGE",
      "settings.network_notifications": "NETWORK NOTIFICATIONS",
      "settings.analytics_refresh": "ANALYTICS REFRESH",
      "settings.export_data": "EXPORT DATA",
      "settings.reset_settings": "RESET SETTINGS",

      // Setting Values
      "settings.enabled": "ENABLED",
      "settings.disabled": "DISABLED",
      "settings.on": "ON",
      "settings.off": "OFF",
      "settings.refresh_every": "Refresh every",
      "settings.seconds": "seconds",

      // Actions
      "actions.export": "EXPORT",
      "actions.reset": "RESET",
      "actions.close": "CLOSE",
      "actions.claim": "CLAIM",

      // Messages
      "messages.saved": "Settings saved successfully!",
      "messages.reset": "Settings reset to defaults!",
      "messages.exported": "Settings exported successfully!",
      "messages.wallet_connect": "Please connect your wallet",
      "messages.loading": "Loading...",
      "messages.processing": "Processing...",

      // Toast Messages
      "toast.approving_spending": "Approving token spending...",
      "toast.toggling_node": "Toggling node...",
      "toast.purchasing_node": "Purchasing node...",
      "toast.claiming_rewards": "Claiming rewards...",
      "toast.node_updated": "Node status updated!",
      "toast.node_purchased": "Node purchased!",
      "toast.rewards_claimed": "Rewards claimed!",
      "toast.upgrade_applied": "Upgrade applied successfully!",
      "toast.purchase_success": "Purchase successful!",
      "toast.connection_failed": "Failed to connect wallet",
      "toast.unknown_error": "Unknown error",
      "toast.transaction_failed": "Transaction failed",
      "toast.wallet_rejected": "Transaction rejected by user",
      "toast.contract_error": "Contract error",

      // Help & Guide
      "help.title": "HELP & GUIDE",
      "help.guide_title": "NODE COMMANDER GUIDE",
      "help.getting_started": "GETTING STARTED",
      "help.purchase_node": "Purchase Your First Node",
      "help.node_cost": "Cost: Configurable by administrator (typically 50 ETCPOWv2)",
      "help.click_purchase": "Click \"Purchase Starter Node\" in the Shop",
      "help.approve_transaction": "Approve the transaction in your wallet",
      "help.node_appears": "Your node will appear in your inventory",
      "help.activate_node": "Activate Your Node",
      "help.select_node": "Select your node from inventory",
      "help.click_activate": "Click \"Activate Node\" to start earning",
      "help.active_earn": "Active nodes earn rewards continuously",
      "help.claim_rewards": "Claim Your Rewards",
      "help.click_claim": "Click \"Claim Rewards\" on any active node",
      "help.rewards_transfer": "Rewards are transferred to your wallet",
      "help.economics": "ECONOMICS & ROI",
      "help.base_earnings": "Base Earnings",
      "help.base_rate": "Base Rate: live on-chain rewardRatePerHour (see Help estimates)",
      "help.daily_base": "Daily earnings depend on tier BPS, hash, bandwidth, uptime, and fleet",
      "help.base_roi": "Break-even usually takes months — check Help live estimates (upgrades matter)",
      "help.upgrade_impact": "Upgrade Impact",
      "help.hash_power_increase": "Hash Power: Increases earning rate",
      "help.uptime_increase": "Uptime: Increases earning multiplier",
      "help.combined_multipliers": "Combined: hash × bandwidth × uptime × fleet",
      "help.roi_examples": "ROI Examples",
      "help.tier": "Tier",
      "help.max_stats": "Max Stats",
      "help.daily_earnings": "Daily Earnings",
      "help.roi": "ROI",
      "help.base": "Base",
      "help.tier2": "Tier 2",
      "help.tier3": "Tier 3",
      "help.tier4": "Tier 4",
      "help.tier5": "Tier 5",
      "help.strategy_tips": "Strategy Tips",
      "help.strategy_start": "Start with base node, save for upgrades",
      "help.strategy_focus": "Upgrades + uptime windows beat chasing flashy ROI claims",
      "help.strategy_diversify": "Multiple nodes unlock fleet bonus when bandwidth is upgraded",
      "help.strategy_higher": "Higher tiers = higher BPS, still a slow shared-pool game",

      // Help - Upgrade System
      "help.upgrade_system": "UPGRADE SYSTEM",
      "help.upgrade_how_work": "How Upgrades Work",
      "help.open_chests": "Open chests to get upgrade NFTs",
      "help.apply_upgrades": "Apply upgrades to your nodes",
      "help.upgrades_permanent": "Upgrades are permanent",
      "help.multiple_upgrades": "Each node can have multiple upgrades",
      "help.upgrade_sources": "Upgrade Sources",
      "help.chests_random": "Chests: Random upgrade drops",
      "help.shop_purchase": "Shop: Buy chests (open from Inventory after next block)",
      "help.achievements_bonus": "Achievements: Bonus upgrades",
      "help.referrals_reward": "Referrals: Reward upgrades",
      "help.upgrade_effects": "Upgrade Effects",
      "help.hash_formula": "Formula: 100 + (hashPower / 50)",
      "help.hash_max": "Max: +50% bonus at 2500",
      "help.uptime_formula": "Formula: 100 + (uptime / 25)",
      "help.uptime_max": "Max: +100% bonus at 2500",
      "help.upgrade_costs": "Upgrade Costs",
      "help.base_price": "Base Price: Configurable by administrator",
      "help.tier1_prices": "Tier prices are configurable by administrator",
      "help.tier2_prices": "Each tier has individually settable prices",
      "help.tier3_prices": "Admin can adjust pricing anytime",
      "help.tier4_prices": "Prices may change based on game economics",
      "help.tier5_prices": "Check current shop prices for latest rates",

      // Help - Chests & Rewards
      "help.chests_rewards": "CHESTS & REWARDS",
      "help.chest_system": "Chest System",
      "help.chest_cost": "Cost: Live per-tier prices in Shop (often a few ETCPOWv2 on testnet)",
      "help.random_upgrades": "Random upgrade NFT drops",
      "help.three_tiers": "Five chest tiers: Basic → Legendary",
      "help.higher_better": "Higher tiers = better upgrades",
      "help.chest_tiers": "Chest Tiers",
      "help.basic_chest": "Basic Chest:",
      "help.basic_25": "• Live shop price",
      "help.basic_common": "• Common upgrades",
      "help.basic_70_rate": "• Opens after next block",
      "help.advanced_chest": "Advanced Chest:",
      "help.advanced_50": "• Live shop price",
      "help.advanced_rare": "• Rare upgrades",
      "help.advanced_25_rate": "• 25% drop rate",
      "help.premium_chest": "Premium Chest:",
      "help.premium_75": "• 75 ETCPOWv2",
      "help.premium_epic": "• Epic upgrades",
      "help.premium_5_rate": "• 5% drop rate",
      "help.rewards_system": "Rewards System",
      "help.nodes_earn": "Nodes earn passively when active",
      "help.rewards_accumulate": "Rewards accumulate continuously",
      "help.claim_anytime": "Claim anytime, no limits",
      "help.multipliers_apply": "Multipliers from upgrades apply",

      // Help - Achievements
      "help.achievements": "🏆 ACHIEVEMENTS",
      "help.achievement_categories": "Achievement Categories",
      "help.nodes_purchase": "Nodes: Purchase and own nodes",
      "help.upgrades_apply": "Upgrades: Apply upgrades to nodes",
      "help.chests_open": "Chests: Open chests for rewards",
      "help.rewards_claim": "Rewards: Claim accumulated earnings",
      "help.special_limited": "Special: Limited-time achievements",
      "help.achievement_rewards": "Achievement Rewards",
      "help.automatic_distribution": "Automatic reward distribution",
      "help.bonus_tokens": "Bonus ETCPOWv2 tokens",
      "help.progress_tracking": "Progress tracking in real-time",
      "help.ten_achievements": "10 achievements total",
      "help.notable_achievements": "Notable Achievements",
      "help.node_pioneer": "Node Pioneer: 1 ETCPOWv2 (first node)",
      "help.node_master": "Node Master: 5 ETCPOWv2 (10 nodes)",
      "help.upgrade_expert": "Upgrade Expert: 2 ETCPOWv2 (10 upgrades)",
      "help.reward_collector": "Reward Collector: 2 ETCPOWv2 (100 claimed)",

      // Help - Referral System
      "help.referral_system": "👥 REFERRAL SYSTEM",
      "help.referrals_work": "How Referrals Work",
      "help.unique_code": "Each wallet gets unique 8-character code",
      "help.share_code": "Share your code with new players",
      "help.when_used": "When they use it, you get rewarded",
      "help.bonus_purchase": "They get a bonus on their first purchase",
      "help.referral_rewards": "Referral Rewards",
      "help.referrer_gets": "Referrer: 1 ETCPOWv2 per referral",
      "help.referred_gets": "Referred: No bonus (fixed reward system)",
      "help.real_time_tracking": "Real-time tracking on blockchain",
      "help.automatic_payout": "Automatic reward distribution",
      "help.referral_strategy": "Referral Strategy",
      "help.social_media": "Share your code on social media",
      "help.create_content": "Create content about the game",
      "help.help_new_players": "Help new players get started",
      "help.build_network": "Build your referral network",

      // Help - Pro Tips
      "help.pro_tips": "🎯 PRO TIPS",
      "help.early_game": "Early Game Strategy",
      "help.start_one_node": "Start with one node, learn the system",
      "help.save_tier2": "Save ETCPOWv2 for Tier 2-3 upgrades",
      "help.open_regularly": "Open chests regularly for upgrades",
      "help.focus_roi": "Use Help live estimates — expect months, not days",
      "help.mid_game": "Mid Game Strategy",
      "help.multiple_nodes": "Build multiple nodes for diversification",
      "help.upgrade_tier3": "Upgrade bandwidth + tier for better multipliers",
      "help.referrals_income": "Use referrals for bonus income",
      "help.complete_achievements": "Complete achievements for rewards",
      "help.end_game": "End Game Strategy",
      "help.max_tier45": "Max out Tier 4-5 nodes",
      "help.build_empire": "Build large node empire",
      "help.optimize_upgrades": "Optimize upgrade combinations",
      "help.help_others": "Help new players with referrals",
      "help.general_tips": "General Tips",
      "help.claim_regularly": "Claim before active windows expire",
      "help.keep_active": "Keep nodes active — reactivation costs may apply",
      "help.monitor_costs": "Monitor upgrade costs vs benefits; pool is shared",
      "help.join_community": "Join community for strategies",

      // Help - FAQ
      "help.faq": "❓ FAQ",
      "help.break_even": "Q: How long until I break even?",
      "help.break_even_a": "A: Usually months. Depends on tier BPS, upgrades, active uptime, reactivation fees, and shared pool pressure — use Help live estimates.",
      "help.lose_node": "Q: Can I lose my node?",
      "help.lose_node_a": "A: No, nodes are NFTs you own permanently.",
      "help.deactivate": "Q: What happens if I deactivate my node?",
      "help.deactivate_a": "A: It stops earning until reactivated. Reactivation fees may apply when enabled on-chain.",
      "help.sell_node": "Q: Can I sell my node?",
      "help.sell_node_a": "A: Yes, as an NFT on the marketplace.",
      "help.guaranteed": "Q: Are rewards guaranteed?",
      "help.guaranteed_a": "A: Accrual follows the smart contract formula; payouts come from a shared rewards pool.",
      "help.prices_change": "Q: Can prices change?",
      "help.prices_change_a": "A: Yes, admin can adjust prices anytime.",

      // Referral Program
      "referral.title": "REFERRAL PROGRAM",
      "referral.bonus": "REWARD: 1 ETCPOWv2",
      "referral.loading": "LOADING REFERRAL DATA...",
      "referral.your_code": "YOUR REFERRAL CODE",
      "referral.copied": "COPIED!",
      "referral.copy": "COPY",
      "referral.generate": "GENERATE",
      "referral.statistics": "REFERRAL STATISTICS",
      "referral.total_referrals": "TOTAL REFERRALS",
      "referral.active_referrals": "ACTIVE REFERRALS",
      "referral.total_earned": "TOTAL EARNED",
      "referral.referral_bonus": "REFERRAL BONUS",
      "referral.share_code": "SHARE YOUR CODE",
      "referral.share_twitter": "SHARE ON TWITTER",
      "referral.share_telegram": "SHARE ON TELEGRAM",
      "referral.program_details": "PROGRAM DETAILS",
      "referral.bonus_rate": "FIXED REWARD:",
      "referral.bonus_desc": "1 ETCPOWv2 per successful referral",
      "referral.payout": "PAYOUT:",
      "referral.payout_desc": "Instantly to your wallet",
      "referral.minimum": "MINIMUM:",
      "referral.minimum_desc": "No minimum - all referrals count!",

      // Inventory
      "inventory.title": "INVENTORY",
      "inventory.chests": "CHESTS",
      "inventory.upgrades": "UPGRADES",
      "inventory.loading": "LOADING INVENTORY...",
      "inventory.chest_id": "CHEST-",
      "inventory.upgrade_id": "UPGRADE-",
      "inventory.tier": "TIER",
      "inventory.rarity": "RARITY:",
      "inventory.stat_type": "TYPE:",
      "inventory.stat_value": "VALUE:",
      "inventory.hash_power": "Hash Power",
      "inventory.bandwidth": "Bandwidth",
      "inventory.uptime": "Uptime",
      "inventory.opened": "OPENED",
      "inventory.ready": "READY",
      "inventory.available": "AVAILABLE",
      "inventory.apply": "APPLY",
      "inventory.open": "OPEN",
      "inventory.select_node_upgrade": "SELECT NODE TO UPGRADE",
      "inventory.no_chests": "NO CHESTS FOUND",
      "inventory.no_chests_desc": "Purchase chests from the shop",
      "inventory.no_upgrades": "NO UPGRADES FOUND",
      "inventory.no_upgrades_desc": "Open chests to get upgrades",
      "inventory.chest_already_opened": "This chest has already been opened!",
      "inventory.upgrade_applied": "Upgrade applied to node",
      "inventory.upgrade_failed": "Failed to apply upgrade",
      "inventory.open_chest_failed": "Failed to open chest"
    }
  },
  de: {
    translation: {
      // Navigation
      "nav.nodes": "NODES",
      "nav.shop": "SHOP",
      "nav.leaderboard": "RANGLISTE",
      "nav.referral": "EMPFEHLUNG",
      "nav.daily": "TÄGLICH",
      "nav.settings": "EINSTELLUNGEN",
      "nav.help": "HILFE",
      "nav.inventory": "INVENTAR",
      "nav.achievements": "ERFOLGE",
      "nav.admin": "ADMIN",

      // Dashboard
      "dashboard.title": "NODE EMPIRE DASHBOARD",
      "dashboard.balance": "ETCPOWv2 Guthaben",
      "dashboard.loading": "Lädt...",
      "dashboard.connect": "Bitte verbinden Sie Ihre Wallet um auf Node Empire zuzugreifen",
      "dashboard.connect_wallet": "Wallet Verbinden",
      "dashboard.disconnect": "Trennen",
      "dashboard.node_commander": "Node Commander",
      "dashboard.connect_description": "Verbinden Sie Ihre Wallet um Ihr virtuelles Node Imperium zu verwalten",
      "dashboard.purchase_starter": "Starter Node Kaufen",
      "dashboard.purchase_price": "(100 ETCPOWv2)",
      "dashboard.your_nodes": "Ihre Nodes",
      "dashboard.active": "AKTIV",
      "dashboard.inactive": "INAKTIV",
      "dashboard.pending": "Ausstehend",
      "dashboard.deactivate": "Deaktivieren",
      "dashboard.activate": "Aktivieren",
      "dashboard.claim": "Abholen",
      "dashboard.node_empire": "Node Empire",
      "dashboard.node_empire_desc": "Verwalten Sie Ihr virtuelles Node Imperium und verdienen Sie ETCPOWv2",
      "dashboard.total_nodes": "Gesamt Nodes",
      "dashboard.active_nodes": "Aktive Nodes",
      "dashboard.node_details": "Node Details",
      "dashboard.hash_power": "Hash Leistung",
      "dashboard.bandwidth": "Bandbreite",
      "dashboard.uptime": "Laufzeit",
      "dashboard.deactivate_node": "Node Deaktivieren",
      "dashboard.activate_node": "Node Aktivieren",
      "dashboard.claim_rewards": "Belohnungen Abholen",

      // Node Management
      "nodes.purchase": "STARTER NODE KAUFEN",
      "nodes.upgrade": "NODE UPGRADE",
      "nodes.activate": "AKTIVIEREN",
      "nodes.deactivate": "DEAKTIVIEREN",
      "nodes.claim": "BELOHNUNGEN ABHOLEN",
      "nodes.pending": "AUSSTEHEND",
      "nodes.tier": "STUFE:",
      "nodes.hash": "HASH:",
      "nodes.band": "BAND:",
      "nodes.uptime": "LAUFZEIT:",

      // Shop
      "shop.title": "NODE EMPIRE SHOP",
      "shop.balance": "ETCPOWv2 Guthaben",
      "shop.purchase": "KAUFEN",
      "shop.unavailable": "NICHT VERFÜGBAR",

      // Items
      "items.node": "NODES",
      "items.chest": "TRUHEN",
      "items.upgrade": "UPGRADES",

      // Chests
      "chests.basic": "Basis Truhe",
      "chests.uncommon": "Ungewöhnliche Truhe",
      "chests.rare": "Seltene Truhe",
      "chests.epic": "Epische Truhe",
      "chests.legendary": "Legendäre Truhe",
      "chests.basic_desc": "Enthält zufällige Belohnungen und Upgrades",
      "chests.uncommon_desc": "Bessere Belohnungen als Basis Truhe",
      "chests.rare_desc": "Hochstufige Belohnungen und Upgrades",
      "chests.epic_desc": "Premium Belohnungen und legendäre Upgrades",
      "chests.legendary_desc": "Ultimative Belohnungen und exklusive Items",

      // Daily Quests
      "daily.title": "TÄGLICHE QUESTS",
      "daily.reset": "Zurücksetzung in",
      "daily.node_owner": "Node Besitzer",
      "daily.chest_owner": "Truhen Sammler",
      "daily.upgrade_owner": "Upgrade Sammler",
      "daily.reward_collector": "Belohnungs Sammler",
      "daily.node_desc": "Kaufe heute mindestens 1 Node (nur Streak)",
      "daily.chest_desc": "Öffne heute mindestens 3 Truhen (nur Streak)",
      "daily.upgrade_desc": "Wende heute mindestens 2 Upgrades an (nur Streak)",
      "daily.reward_desc": "Hole heute On-Chain-Belohnungen von mind. 1 Node ab (Quest zählt lokal)",
      "daily.in_progress": "IN BEARBEITUNG",
      "daily.completed": "ABGESCHLOSSEN",
      "daily.completed_msg": "Streak notiert!\n\n✅ {{title}}\n\nLokaler Habit-Tracker — kein ETCPOWv2-Faucet.",
      "daily.loading_quests": "QUESTS LADEN...",
      "daily.completed_button": "ERFASST",
      "daily.in_progress_button": "IN BEARBEITUNG",

      // Rarity Levels
      "rarity.common": "Gewöhnlich",
      "rarity.uncommon": "Ungewöhnlich",
      "rarity.rare": "Selten",
      "rarity.epic": "Episch",
      "rarity.legendary": "Legendär",
      "rarity.unknown": "Unbekannt",

      // Admin Panel
      "admin.title": "ADMIN STEUERUNG",
      "admin.owner_mode": "BESITZER MODUS",
      "admin.price_controls": "Preissteuerung",
      "admin.node_price": "Node Preis (ETCPOWv2)",
      "admin.chest_prices": "Truhen Preise (ETCPOWv2)",
      "admin.chest_tier_basic": "Basis",
      "admin.chest_tier_uncommon": "Ungewöhnlich",
      "admin.chest_tier_rare": "Selten",
      "admin.chest_tier_epic": "Episch",
      "admin.chest_tier_legendary": "Legendär",
      "admin.reward_rate": "Belohnungsrate (ETCPOWv2/Stunde)",
      "admin.upgrade_price": "Upgrade Basispreis (ETCPOWv2)",
      "admin.referral_reward": "Empfehlungsbelohnung (ETCPOWv2)",
      "admin.referral_bonus": "Empfehlungsbonus (%)",
      "admin.contract_management": "Vertragsverwaltung",
      "admin.contract_balances": "Vertragsguthaben",
      "admin.fund_contract": "Vertrag finanzieren",
      "admin.withdraw_funds": "Gelder abheben",
      "admin.game_controls": "Spielsteuerung",
      "admin.pause_game": "Spiel pausieren",
      "admin.resume_game": "Spiel fortsetzen",
      "admin.update": "Aktualisieren",
      "admin.set": "Festlegen",

      // Achievements
      "achievements.title": "ERFOLGE",
      "achievements.loading": "ERFOLGE LADEN...",
      "achievements.all": "ALLE",
      "achievements.nodes": "NODES",
      "achievements.upgrades": "UPGRADES",
      "achievements.chests": "TRUHEN",
      "achievements.earnings": "EINKOMMEN",
      "achievements.special": "SPEZIAL",
      "achievements.reward": "BELOHNUNG:",
      "achievements.completed": "✓ ABGESCHLOSSEN",
      "achievements.progress": "%",
      "achievements.unlocked": "FREIGESCHALTET:",

      // Achievement Names
      "achievement.node_pioneer": "Node Pionier",
      "achievement.node_collector": "Node Sammler",
      "achievement.node_master": "Node Meister",
      "achievement.upgrade_beginner": "Upgrade Anfänger",
      "achievement.upgrade_expert": "Upgrade Experte",
      "achievement.lucky_opener": "Glücklicher Öffner",
      "achievement.chest_hunter": "Truhen Jäger",
      "achievement.first_claim": "Erste Abholung",
      "achievement.reward_collector": "Belohnungs Sammler",
      "achievement.early_adopter": "Früher Adoptierer",

      // Achievement Descriptions
      "achievement.node_pioneer_desc": "Kaufe deinen ersten virtuellen Node",
      "achievement.node_collector_desc": "Besitze 5 virtuelle Nodes",
      "achievement.node_master_desc": "Besitze 10 virtuelle Nodes",
      "achievement.upgrade_beginner_desc": "Wende dein erstes Upgrade an",
      "achievement.upgrade_expert_desc": "Wende 10 Upgrades an",
      "achievement.lucky_opener_desc": "Öffne 10 Truhen",
      "achievement.chest_hunter_desc": "Öffne 25 Truhen",
      "achievement.first_claim_desc": "Hohle deine ersten Belohnungen ab",
      "achievement.reward_collector_desc": "Hohle insgesamt 100 ETCPOWv2 ab",
      "achievement.early_adopter_desc": "Sei einer der ersten 100 Benutzer",

      // Settings
      "settings.title": "EINSTELLUNGEN",
      "settings.config": "KONFIGURATION",
      "settings.general": "ALLGEMEIN",
      "settings.language": "SPRACHE",
      "settings.advanced": "ERWEITERT",
      "settings.account": "ACCOUNT",

      // Setting Labels
      "settings.sound": "SOUNDEFFEKTE",
      "settings.particles": "PARTIKELEFFEKT",
      "settings.notifications": "BENACHRICHTIGUNGEN",
      "settings.language_select": "SPRACHE",
      "settings.network_notifications": "NETZWERK BENACHRICHTIGUNGEN",
      "settings.analytics_refresh": "ANALYTICS AKTUALISIERUNG",
      "settings.export_data": "DATEN EXPORTIEREN",
      "settings.reset_settings": "EINSTELLUNGEN ZURÜCKSETZEN",

      // Setting Values
      "settings.enabled": "AKTIVIERT",
      "settings.disabled": "DEAKTIVIERT",
      "settings.on": "AN",
      "settings.off": "AUS",
      "settings.refresh_every": "Aktualisiere alle",
      "settings.seconds": "Sekunden",

      // Actions
      "actions.export": "EXPORTIEREN",
      "actions.reset": "ZURÜCKSETZEN",
      "actions.close": "SCHLIESSEN",
      "actions.claim": "ABHOLEN",

      // Messages
      "messages.saved": "Einstellungen erfolgreich gespeichert!",
      "messages.reset": "Einstellungen auf Standard zurückgesetzt!",
      "messages.exported": "Einstellungen erfolgreich exportiert!",
      "messages.wallet_connect": "Bitte verbinden Sie Ihre Wallet",
      "messages.loading": "Lädt...",
      "messages.processing": "Verarbeitet...",

      // Toast Messages
      "toast.approving_spending": "Token-Ausgaben genehmigen...",
      "toast.toggling_node": "Node umschalten...",
      "toast.purchasing_node": "Node kaufen...",
      "toast.claiming_rewards": "Belohnungen abholen...",
      "toast.node_updated": "Node-Status aktualisiert!",
      "toast.node_purchased": "Node gekauft!",
      "toast.rewards_claimed": "Belohnungen abgeholt!",
      "toast.upgrade_applied": "Upgrade erfolgreich angewendet!",
      "toast.purchase_success": "Kauf erfolgreich!",
      "toast.connection_failed": "Wallet-Verbindung fehlgeschlagen",
      "toast.unknown_error": "Unbekannter Fehler",
      "toast.transaction_failed": "Transaktion fehlgeschlagen",
      "toast.wallet_rejected": "Transaktion vom Benutzer abgelehnt",
      "toast.contract_error": "Vertragsfehler",

      // Help & Guide
      "help.title": "HILFE & ANLEITUNG",
      "help.guide_title": "NODE COMMANDER ANLEITUNG",
      "help.getting_started": "ERSTE SCHRITTE",
      "help.purchase_node": "Kaufen Sie Ihren Ersten Node",
      "help.node_cost": "Kosten: 50 ETCPOWv2 (einstellbar durch Admin)",
      "help.click_purchase": "Klicken Sie \"Starter Node Kaufen\" im Shop",
      "help.approve_transaction": "Genehmigen Sie die Transaktion in Ihrer Wallet",
      "help.node_appears": "Ihr Node erscheint in Ihrem Inventar",
      "help.activate_node": "Aktivieren Sie Ihren Node",
      "help.select_node": "Wählen Sie Ihren Node aus dem Inventar",
      "help.click_activate": "Klicken Sie \"Node Aktivieren\" um zu verdienen",
      "help.active_earn": "Aktive Nodes verdienen kontinuierlich Belohnungen",
      "help.claim_rewards": "Holen Sie Ihre Belohnungen ab",
      "help.click_claim": "Klicken Sie \"Belohnungen Abholen\" auf jedem aktiven Node",
      "help.rewards_transfer": "Belohnungen werden auf Ihre Wallet übertragen",
      "help.claim_anytime": "Jederzeit abholen - Belohnungen sammeln sich an",
      "help.economics": "WIRTSCHAFT & ROI",
      "help.base_earnings": "Basis Einnahmen",
      "help.base_rate": "Basis Rate: live on-chain rewardRatePerHour (siehe Hilfe-Schätzungen)",
      "help.daily_base": "Tagesverdienst hängt von Tier-BPS, Hash, Bandwidth, Uptime und Fleet ab",
      "help.base_roi": "Break-even dauert meist Monate — siehe Hilfe-Schätzungen (Upgrades zählen)",
      "help.upgrade_impact": "Upgrade Auswirkungen",
      "help.hash_power_increase": "Hash Leistung: Erhöht die Verdienstrate",
      "help.uptime_increase": "Laufzeit: Erhöht den Verdienst-Multiplikator",
      "help.combined_multipliers": "Kombiniert: Hash × Bandwidth × Uptime × Fleet",
      "help.roi_examples": "ROI Beispiele",
      "help.tier": "Stufe",
      "help.max_stats": "Max Stats",
      "help.daily_earnings": "Tägliche Einnahmen",
      "help.roi": "ROI",
      "help.base": "Basis",
      "help.tier2": "Stufe 2",
      "help.tier3": "Stufe 3",
      "help.tier4": "Stufe 4",
      "help.tier5": "Stufe 5",
      "help.strategy_tips": "Strategie Tipps",
      "help.strategy_start": "Mit Basis Node starten, für Upgrades sparen",
      "help.strategy_focus": "Upgrades + aktive Fenster schlagen bunte ROI-Versprechen",
      "help.strategy_diversify": "Mehrere Nodes + upgraded Bandwidth freischalten Fleet-Bonus",
      "help.strategy_higher": "Höhere Stufen = höheres BPS, trotzdem langsames Shared-Pool-Spiel",

      // Help - Upgrade System
      "help.upgrade_system": "UPGRADE SYSTEM",
      "help.upgrade_how_work": "Wie Upgrades funktionieren",
      "help.open_chests": "Öffne Truhen um Upgrade NFTs zu bekommen",
      "help.apply_upgrades": "Wende Upgrades auf deine Nodes an",
      "help.upgrades_permanent": "Upgrades sind permanent",
      "help.multiple_upgrades": "Jeder Node kann mehrere Upgrades haben",
      "help.upgrade_sources": "Upgrade Quellen",
      "help.chests_random": "Truhen: Zufällige Upgrade Drops",
      "help.shop_purchase": "Shop: Kaufe Upgrade NFTs",
      "help.achievements_bonus": "Erfolge: Bonus Upgrades",
      "help.referrals_reward": "Empfehlungen: Belohnungs Upgrades",
      "help.upgrade_effects": "Upgrade Effekte",
      "help.upgrade_costs": "Upgrade Kosten",
      "help.base_price": "Basispreis: 10 ETCPOWv2",
      "help.tier1_prices": "Stufe 1: 10-20 ETCPOWv2 pro Upgrade",
      "help.tier2_prices": "Stufe 2: 20-50 ETCPOWv2 pro Upgrade",
      "help.tier3_prices": "Stufe 3: 50-100 ETCPOWv2 pro Upgrade",
      "help.tier4_prices": "Stufe 4: 100-250 ETCPOWv2 pro Upgrade",
      "help.tier5_prices": "Stufe 5: 250-500 ETCPOWv2 pro Upgrade",

      // Help - Chests & Rewards
      "help.chests_rewards": "📦 TRUHEN & BELOHNUNGEN",
      "help.chest_system": "Truhen System",
      "help.chest_cost": "Kosten: 25 ETCPOWv2 pro Truhe",
      "help.random_upgrades": "Zufällige Upgrade NFT Drops",
      "help.three_tiers": "Drei Stufen: Basis, Fortgeschritten, Premium",
      "help.higher_better": "Höhere Stufen = bessere Upgrades",
      "help.chest_tiers": "Truhen Stufen",
      "help.basic_chest": "Basis Truhe:",
      "help.basic_25": "• 25 ETCPOWv2",
      "help.basic_common": "• Gewöhnliche Upgrades",
      "help.basic_70_rate": "• 70% Drop Rate",
      "help.advanced_chest": "Fortgeschrittene Truhe:",
      "help.advanced_50": "• 50 ETCPOWv2",
      "help.advanced_rare": "• Seltene Upgrades",
      "help.advanced_25_rate": "• 25% Drop Rate",
      "help.premium_chest": "Premium Truhe:",
      "help.premium_75": "• 75 ETCPOWv2",
      "help.premium_epic": "• Epische Upgrades",
      "help.premium_5_rate": "• 5% Drop Rate",
      "help.rewards_system": "Belohnungssystem",
      "help.nodes_earn": "Nodes verdienen passiv wenn aktiv",
      "help.rewards_accumulate": "Belohnungen sammeln sich kontinuierlich",
      "help.multipliers_apply": "Multiplikatoren von Upgrades gelten",

      // Help - Achievements
      "help.achievements": "🏆 ERFOLGE",
      "help.achievement_categories": "Erfolgs Kategorien",
      "help.nodes_purchase": "Nodes: Kaufe und besitze Nodes",
      "help.upgrades_apply": "Upgrades: Wende Upgrades auf Nodes an",
      "help.chests_open": "Truhen: Öffne Truhen für Belohnungen",
      "help.rewards_claim": "Belohnungen: Sammle verdiente Beträge ein",
      "help.special_limited": "Speziell: Zeitlich begrenzte Erfolge",
      "help.achievement_rewards": "Erfolgs Belohnungen",
      "help.automatic_distribution": "Automatische Belohnungsverteilung",
      "help.bonus_tokens": "Bonus ETCPOWv2 Token",
      "help.progress_tracking": "Echtzeit-Fortschrittsverfolgung",
      "help.ten_achievements": "10 Erfolge insgesamt",
      "help.notable_achievements": "Bemerkenswerte Erfolge",
      "help.node_pioneer": "Node Pionier: 1 ETCPOWv2 (erster Node)",
      "help.node_master": "Node Meister: 5 ETCPOWv2 (10 Nodes)",
      "help.upgrade_expert": "Upgrade Experte: 2 ETCPOWv2 (10 Upgrades)",
      "help.reward_collector": "Belohnungs Sammler: 2 ETCPOWv2 (100 abgeholt)",

      // Help - Referral System
      "help.referral_system": "👥 EMPFEHLUNGSSYSTEM",
      "help.referrals_work": "Wie Empfehlungen funktionieren",
      "help.unique_code": "Jede Wallet bekommt einen einzigartigen 8-stelligen Code",
      "help.share_code": "Teile deinen Code mit neuen Spielern",
      "help.when_used": "Wenn sie ihn verwenden, wirst du belohnt",
      "help.bonus_purchase": "Sie bekommen einen Bonus beim ersten Kauf",
      "help.referral_rewards": "Empfehlungs Belohnungen",
      "help.referrer_gets": "Empfehler: 1 ETCPOWv2 pro Empfehlung",
      "help.referred_gets": "Empfohlener: Kein Bonus (festes Belohnungssystem)",
      "help.real_time_tracking": "Echtzeit-Verfolgung auf der Blockchain",
      "help.automatic_payout": "Automatische Belohnungsverteilung",
      "help.referral_strategy": "Empfehlungs Strategie",
      "help.social_media": "Teile deinen Code in sozialen Medien",
      "help.create_content": "Erstelle Inhalte über das Spiel",
      "help.help_new_players": "Hilf neuen Spielern beim Einstieg",
      "help.build_network": "Baue dein Empfehlungsnetzwerk auf",

      // Help - Pro Tips
      "help.pro_tips": "🎯 PRO TIPPS",
      "help.early_game": "Early Game Strategie",
      "help.start_one_node": "Starte mit einem Node, lerne das System",
      "help.save_tier2": "Sammle ETCPOWv2 für Stufe 2-3 Upgrades",
      "help.open_regularly": "Öffne regelmäßig Truhen für Upgrades",
      "help.focus_roi": "Nutze Hilfe-Schätzungen — Monate, nicht Tage",
      "help.mid_game": "Mid Game Strategie",
      "help.multiple_nodes": "Baue mehrere Nodes für Diversifikation",
      "help.upgrade_tier3": "Upgrade Bandwidth + Tier für bessere Multiplikatoren",
      "help.referrals_income": "Nutze Empfehlungen für Bonus Einnahmen",
      "help.complete_achievements": "Schließe Erfolge für Belohnungen ab",
      "help.end_game": "End Game Strategie",
      "help.max_tier45": "Maximiere Stufe 4-5 Nodes",
      "help.build_empire": "Baue ein großes Node Imperium",
      "help.optimize_upgrades": "Optimiere Upgrade Kombinationen",
      "help.help_others": "Hilf neuen Spielern mit Empfehlungen",
      "help.general_tips": "Allgemeine Tipps",
      "help.claim_regularly": "Hole ab bevor aktive Fenster ablaufen",
      "help.keep_active": "Halte Nodes aktiv — Reaktivierung kann kosten",
      "help.monitor_costs": "Überwache Upgrade Kosten vs Nutzen; Pool ist geteilt",
      "help.join_community": "Trete der Community für Strategien bei",

      // Help - FAQ
      "help.faq": "❓ FAQ",
      "help.break_even": "F: Wie lange bis zum Break-Even?",
      "help.break_even_a": "A: Meist Monate. Hängt von Tier-BPS, Upgrades, aktiver Laufzeit, Reaktivierungsgebühren und Shared Pool ab — siehe Hilfe-Schätzungen.",
      "help.lose_node": "F: Kann ich meinen Node verlieren?",
      "help.lose_node_a": "A: Nein, Nodes sind NFTs die du dauerhaft besitzt.",
      "help.deactivate": "F: Was passiert wenn ich meinen Node deaktiviere?",
      "help.deactivate_a": "A: Er stoppt bis zur Reaktivierung. Reaktivierungsgebühren können on-chain gelten.",
      "help.sell_node": "F: Kann ich meinen Node verkaufen?",
      "help.sell_node_a": "A: Ja, als NFT auf dem Marktplatz.",
      "help.guaranteed": "F: Sind Belohnungen garantiert?",
      "help.guaranteed_a": "A: Accrual folgt der Smart-Contract-Formel; Auszahlungen kommen aus einem geteilten Rewards-Pool.",
      "help.prices_change": "F: Können Preise sich ändern?",
      "help.prices_change_a": "A: Ja, Admin kann Preise jederzeit anpassen.",

      // Referral Program
      "referral.title": "EMPFEHLUNGSPROGRAMM",
      "referral.bonus": "BELOHNUNG: 1 ETCPOWv2",
      "referral.loading": "EMPFEHLUNGSDATEN LADEN...",
      "referral.your_code": "IHR EMPFEHLUNGSCODE",
      "referral.copied": "KOPIERT!",
      "referral.copy": "KOPIEREN",
      "referral.generate": "ERSTELLEN",
      "referral.statistics": "EMPFEHLUNGSSTATISTIKEN",
      "referral.total_referrals": "GESAMTE EMPFEHLUNGEN",
      "referral.active_referrals": "AKTIVE EMPFEHLUNGEN",
      "referral.total_earned": "GESAMT VERDIENT",
      "referral.referral_bonus": "EMPFEHLUNGSBONUS",
      "referral.share_code": "TEILEN SIE IHREN CODE",
      "referral.share_twitter": "AUF TWITTER TEILEN",
      "referral.share_telegram": "AUF TELEGRAM TEILEN",
      "referral.program_details": "PROGRAMMDETAILS",
      "referral.bonus_rate": "FESTE BELOHNUNG:",
      "referral.bonus_desc": "1 ETCPOWv2 pro erfolgreicher Empfehlung",
      "referral.payout": "AUSZAHLUNG:",
      "referral.payout_desc": "Sofort auf Ihre Wallet",
      "referral.minimum": "MINIMUM:",
      "referral.minimum_desc": "Kein Minimum - alle Empfehlungen zählen!",

      // Inventory
      "inventory.title": "INVENTAR",
      "inventory.chests": "TRUHEN",
      "inventory.upgrades": "UPGRADES",
      "inventory.loading": "INVENTAR LADEN...",
      "inventory.chest_id": "TRUHE-",
      "inventory.upgrade_id": "UPGRADE-",
      "inventory.tier": "STUFE",
      "inventory.rarity": "SELTERNHEIT:",
      "inventory.stat_type": "TYP:",
      "inventory.stat_value": "WERT:",
      "inventory.hash_power": "Hash Leistung",
      "inventory.bandwidth": "Bandbreite",
      "inventory.uptime": "Laufzeit",
      "inventory.opened": "GEÖFFNET",
      "inventory.ready": "BEREIT",
      "inventory.available": "VERFÜGBAR",
      "inventory.apply": "ANWENDEN",
      "inventory.open": "ÖFFNEN",
      "inventory.select_node_upgrade": "NODE ZUM UPGRADE AUSWÄHLEN",
      "inventory.no_chests": "KEINE TRUHEN GEFUNDEN",
      "inventory.no_chests_desc": "Kaufen Sie Truhen im Shop",
      "inventory.no_upgrades": "KEINE UPGRADES GEFUNDEN",
      "inventory.no_upgrades_desc": "Öffnen Sie Truhen um Upgrades zu bekommen",
      "inventory.chest_already_opened": "Diese Truhe wurde bereits geöffnet!",
      "inventory.upgrade_applied": "Upgrade auf Node angewendet",
      "inventory.upgrade_failed": "Upgrade konnte nicht angewendet werden",
      "inventory.open_chest_failed": "Truhe konnte nicht geöffnet werden"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    }
  });

export default i18n;
